import { render, staticRenderFns } from "./fix-info.vue?vue&type=template&id=6a28dec0&scoped=true"
import script from "./fix-info.vue?vue&type=script&lang=ts"
export * from "./fix-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28dec0",
  null
  
)

export default component.exports